import { useEffect, useRef, useState } from 'react';

import Button from '~/components/common/Button';
import { type ITrackingProps } from '~/services/actions/tracking-actions';
import { type SubsProduct } from '~/types/subs-product';

import { type Selection } from '../hooks/use-subscribe';

import styles from './SubscriptionCard.module.css';

export const SubscriptionCard = ({
  buttonCtaText,
  cardName,
  handleSubscribe,
  product,
  sendCustomEvent,
  userId







}: {buttonCtaText: string;cardName: string;handleSubscribe: (selection: Selection) => void;product: SubsProduct;sendCustomEvent: (obj: ITrackingProps) => void;userId: string;}) => {
  const { priceFormatted, tags, term } = product;
  const [isLoading, setIsLoading] = useState(false);

  const timeoutRef = useRef<NodeJS.Timeout>();
  useEffect(() => {
    const disableLoading = () => {
      timeoutRef.current = setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    };
    window.addEventListener('OC:ModalClosed', disableLoading);
    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener('OC:ModalClosed', disableLoading);
    };
  }, []);

  const onClick = () => {
    setIsLoading(true);
    sendCustomEvent({
      event: 'subscriptionOffer',
      eventLabel: 'subscription-button-clicked',
      event_name: 'subscriptionOffer',
      product: `${priceFormatted}/${term}`,
      userId
    });
    handleSubscribe({
      product: product.price,
      term: term as Selection['term']
    });
  };

  return (
    <div className={styles.card} data-testid="subscription-card">
			<div>
				<h3 className={styles.cardHeader}>
					<b>{priceFormatted}</b>/{term}
				</h3>
				{tags &&
        <ul className={styles.tagWrapper}>
						{tags.map((tag, index) =>
          <li className={styles.tag} key={`${cardName}-tag-${index}`}>
								{tag}
							</li>
          )}
					</ul>
        }
			</div>
			<Button
        buttonText={buttonCtaText}
        isLoading={isLoading}
        onClick={onClick}
        shrinkTextOnMobile />

		</div>);

};